import store from '@/store'

let refreshing = null

// 多个请求同时过期时，只提交一次刷新，避免刷新凭据被重复使用。
export function renewSession() {
  if (!refreshing) {
    refreshing = store.dispatch('user/refreshToken').finally(() => {
      refreshing = null
    })
  }
  return refreshing
}

export function isSessionExpired(error) {
  return !!(error && (error.sessionExpired ||
    (error.response && error.response.status === 401) ||
    (error.response && error.response.status === 400 && error.response.data &&
      error.response.data.error === 'invalid_grant')))
}
